// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.blok-date[data-v-a38b1d54] {\n  font-style: italic;\n  display: inline-block;\n  padding: 5px;\n}\n", ""]);
// Exports
module.exports = exports;
